import { useCallback } from 'react';
import { useNotify } from 'react-admin';

interface Body {
  errors: string[];
}

interface ResponseError {
  body: Body;
}

export const useErrorHandling = () => {
  const notify = useNotify();

  const handleError = useCallback(
    (error: ResponseError) => {
      if (error?.body?.errors) {
        const message = error?.body?.errors?.length ? error?.body?.errors!.join('\n') : '';
        notify(message, { type: 'error' });
      } else {
        notify('An unknown error occurred, please try again later', {
          type: 'error',
        });
      }
    },
    [notify]
  );

  return [handleError];
};
